import createDOMPurify from 'dompurify';
import { decode } from 'html-entities';

const base64Encode = (string) => {
  const encodedString = btoa(string);
  return encodedString.replace(/=+$/, '');
};

const decodeHtmlEntities = (encodedString) => decode(encodedString);

const purifyDom = (html) => {
  const config = {
    ADD_ATTR: ['target'],
  };
  const domPurify = createDOMPurify(window);
  return { __html: domPurify.sanitize(html, config) };
};

const prepareHtml = (html) => purifyDom(decodeHtmlEntities(html));

const safeStringCompare = (str1, str2) => (str1 || '').toLowerCase().trim() === (str2 || '').toLowerCase().trim();

export { base64Encode, prepareHtml, safeStringCompare };
